import { QueryClientProvider } from "@tanstack/react-query";
import React from "react";
import { API } from "../../API";
import { queryClient } from "../../App";
import { CaregiverMobile } from "../../messages";
import StoreRedirect from "../StoreRedirect";
import AuthScreen from "./AuthScreen";

interface Props {
  onLogin: (api: API) => void;
  onVersionOutdated: () => void;
  onUserLocked: (phoneNumber: string) => void;
  onComplete: (params: {
    api: API;
    caregiver: CaregiverMobile;
    isNewCaregiver: boolean;
    shouldSkipPromo: boolean;
  }) => void;
}

const AuthActivity = (props: Props) => {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthScreen
        onLogin={props.onLogin}
        onVersionOutdated={props.onVersionOutdated}
        onUserLocked={props.onUserLocked}
        onComplete={props.onComplete}
      />
      <StoreRedirect />
    </QueryClientProvider>
  );
};

export default AuthActivity;
